"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SnackbarProvider", {
  enumerable: true,
  get: function get() {
    return _SnackbarProvider.default;
  }
});
Object.defineProperty(exports, "snackbarReducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});
exports.snackbarActions = void 0;

var _SnackbarProvider = _interopRequireDefault(require("./SnackbarProvider"));

var _reducer = _interopRequireDefault(require("./reducer"));

var snackbarActions = _interopRequireWildcard(require("./actions"));

exports.snackbarActions = snackbarActions;

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}